import { defineComponent as _defineComponent } from 'vue'
import ContrlPanl from '@/components/control-panl/index.vue'
import { genGroup, CtrlAtom } from './constant'
import { computed, shallowRef } from 'vue'
import { AlignmentMode, DataSetRaw } from '@/sdk'
import { watchGroupChange } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'control',
  props: {
    alignment: { type: Object, required: true },
    select: { type: Array, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;


const ctrolGroup = genGroup(
  props.alignment,
  computed(() => props.select)
)
const runs = shallowRef<Array<CtrlAtom>>([ctrolGroup[0].ctrls[0]])
const useSetting = (ctrl: CtrlAtom) => {
  ctrl.handler()
}

watchGroupChange(
  runs,
  atom => {
    atom.handler()
  },
  (atom: any) => {
    atom.unHandler && atom.unHandler()
  }
)

const __returned__ = { props, ctrolGroup, runs, useSetting, ContrlPanl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})